// src/hooks/useUsers.js
import { useState, useCallback } from "react";
import { userApi } from "../api/userApi";

export function useUsers() {
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  const clearError = () => setError(null);

  const fetchAll = useCallback(async (filters) => {
    setLoading(true);
    setError(null);
    try {
      const res = await userApi.getAll(filters);
      setUsers(res.data ?? []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async (payload) => {
    const res     = await userApi.create(payload);
    const created = res.data;
    setUsers(prev => [...prev, created]);
    return created;
  }, []);

  const update = useCallback(async (id, payload) => {
    const res     = await userApi.update(id, payload);
    const updated = res.data;
    setUsers(prev => prev.map(u => u.CRM_UID === id ? updated : u));
    return updated;
  }, []);

  const remove = useCallback(async (id) => {
    await userApi.delete(id);
    setUsers(prev => prev.filter(u => u.CRM_UID !== id));
  }, []);

  return { users, loading, error, clearError, fetchAll, create, update, remove };
}
